export { default } from './withScaleRatingItemStyle';
